import React, { createContext, useState, useCallback } from 'react';

// 1. 컨텍스트 생성
export const UIContext = createContext();

// 2. 컨텍스트 프로바이더(Provider) 정의
export function UIProvider({ children }) {
  const [isWorkOrderOpen, setIsWorkOrderOpen] = useState(false);
  const [initialWorkOrderData, setInitialWorkOrderData] = useState(null);

  // 작업 지시 창을 여는 함수 (초기 데이터와 함께)
  const openWorkOrder = useCallback((data = null, options = {}) => {
    setInitialWorkOrderData({ ...data, ...options });
    setIsWorkOrderOpen(true);
  }, []);

  // 작업 지시 창을 닫는 함수
  const closeWorkOrder = useCallback(() => {
    setIsWorkOrderOpen(false);
    setInitialWorkOrderData(null);
  }, []);

  // 컨텍스트가 제공할 값
  const value = {
    isWorkOrderOpen,
    initialWorkOrderData,
    openWorkOrder,
    closeWorkOrder,
  };

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}
